// extracted by mini-css-extract-plugin
export var aiDigitalTwinWrapper = "AiDigitalTwin-module--aiDigitalTwinWrapper--BCpAu";
export var bannerImageDesktop = "AiDigitalTwin-module--bannerImageDesktop--8lsed";
export var bannerImageMobile = "AiDigitalTwin-module--bannerImageMobile--pNG-t";
export var bannerSection = "AiDigitalTwin-module--bannerSection--u-6pl";
export var cardsSection = "AiDigitalTwin-module--cardsSection--kleiU";
export var learnMoreBtn = "AiDigitalTwin-module--learnMoreBtn--kqjPX";
export var learnMoreSection = "AiDigitalTwin-module--learnMoreSection--8UfhG";